import { useTranslation } from 'react-i18next';

import { ErrorState } from '@/components/feedback/ErrorState';
import { PageMeta } from '@/components/layout/PageMeta';
import { Stack } from '@/components/layout/Stack';
import { SupportContacts } from '@/components/layout/SupportContacts';
import { env } from '@/config/env';

export function InvalidLinkPage() {
  const { t } = useTranslation('errors');
  const { t: tCommon } = useTranslation('common');
  const { t: tCashier } = useTranslation('cashier');
  const { t: tOutcome } = useTranslation('outcome');

  return (
    <Stack gap="md">
      <PageMeta title={t('http.401.title')} />
      <ErrorState
        title={t('http.401.title')}
        body={t('http.401.body')}
        copyLabel={tCommon('actions.copy')}
        copiedLabel={tCommon('actions.copied')}
        manualCopyLabel={tCommon('actions.manualCopy')}
      />
      <p className="text-text-muted text-center text-sm leading-relaxed">{tCashier('invalidLink.noRetry')}</p>
      <SupportContacts
        email={null}
        phone={null}
        fallbackUrl={env.supportUrl}
        heading={tOutcome('support.title')}
        emailLabel={tCommon('footer.supportEmail')}
        phoneLabel={tCommon('footer.supportPhone')}
        fallbackLabel={tCommon('footer.support')}
      />
    </Stack>
  );
}
